import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Eye, EyeOff, ShieldCheck } from "lucide-react";
import { useAdmin } from "@/admin/AdminContext";
import { errMsg } from "@/lib/api";

export default function AdminLogin() {
  const { staff, login } = useAdmin();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [show, setShow] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (staff) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { await login(f.email, f.password); nav("/admin"); } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };
  const inp = "w-full bg-white border border-zinc-300 rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:border-[#7C3AED] transition-colors";
  return (
    <div className="min-h-screen grid place-items-center bg-zinc-50 grid-bg p-6">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border border-zinc-200 shadow-sm rounded-sm p-8 space-y-5 fade-up" data-testid="admin-login-form">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 bg-[#7C3AED] grid place-items-center rounded-sm"><ShieldCheck size={16} className="text-white" /></div>
          <div><p className="font-display font-black text-zinc-900 leading-none">Fx Cotrader</p><p className="label-xs mt-1">Admin Portal</p></div>
        </div>
        <div>
          <h1 className="text-2xl font-black text-zinc-900">Staff sign in</h1>
          <p className="text-xs text-zinc-500 mt-1">Restricted to Super Admins, Admins and Account Managers. Separate from the trader login.</p>
        </div>
        <label className="block space-y-1.5"><span className="label-xs">Email</span>
          <input className={inp} type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="admin-login-email" /></label>
        <div className="space-y-1.5"><span className="label-xs">Password</span>
          <div className="relative">
            <input className={`${inp} pr-10`} type={show ? "text" : "password"} required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="admin-login-password" />
            <button type="button" onClick={() => setShow(!show)} aria-label={show ? "Hide password" : "Show password"} data-testid="admin-toggle-password"
              className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-zinc-500 hover:text-zinc-900">{show ? <EyeOff size={16} /> : <Eye size={16} />}</button>
          </div>
        </div>
        {err && <p className="text-sm text-[#DC2626]" data-testid="admin-login-error">{err}</p>}
        <button disabled={busy} className="w-full py-2.5 bg-[#7C3AED] hover:bg-[#6D28D9] text-white text-sm font-semibold rounded-sm transition-colors disabled:opacity-50" data-testid="admin-login-submit">
          {busy ? "Verifying…" : "Sign in to portal"}
        </button>
        <a href="/login" className="block text-center text-xs text-zinc-500 hover:text-zinc-900" data-testid="admin-login-trader-link">Trader login →</a>
      </form>
    </div>
  );
}
